import { Routes } from '@angular/router';
import { AuthGuard } from '@auth0/auth0-angular';
import { Roles } from '@plantefeve/common/constants/enums/roles.enum';
import { NO_ACCESS_ROUTE, roleGuard } from '@plantefeve/common/guards/role.guard';
import { UserDetailComponent } from '@plantefeve/common/shared/components/users/user-detail/user-detail.component';
import { NoAccessComponent } from './modules/no-access/no-access.component';
import { linkedRelationGuard, NOT_LINKED_ROUTE } from './modules/portal-context/linked-relation.guard';
import { NotLinkedComponent } from './modules/portal-context/not-linked.component';

export const routes: Routes = [
  {
    path: NO_ACCESS_ROUTE,
    canActivate: [AuthGuard],
    component: NoAccessComponent,
  },
  {
    path: '',
    canActivate: [AuthGuard, roleGuard],
    data: { roles: [Roles.PortalUser] },
    children: [
      {
        path: '',
        redirectTo: 'orders',
        pathMatch: 'full',
      },
      {
        path: 'orders',
        canActivate: [linkedRelationGuard],
        loadChildren: () => import('./modules/orders/orders.routing').then((r) => r.OrderRoutes),
      },
      {
        path: 'invoices',
        canActivate: [linkedRelationGuard],
        loadChildren: () => import('./modules/invoices/invoices.routing').then((r) => r.InvoiceRoutes),
      },
      {
        path: NOT_LINKED_ROUTE,
        component: NotLinkedComponent,
      },
      {
        path: 'users/details',
        component: UserDetailComponent,
        pathMatch: 'full',
      },
    ],
  },
];
